import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/',
    component: () => import('@/layout/Layout.vue'),
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '首页' }
      },
      {
        path: 'brand',
        name: 'Brand',
        component: () => import('@/views/brand/BrandList.vue'),
        meta: { title: '品牌管理' }
      },
      {
        path: 'store',
        name: 'Store',
        component: () => import('@/views/store/StoreList.vue'),
        meta: { title: '店铺管理' }
      },
      {
        path: 'product',
        name: 'Product',
        component: () => import('@/views/product/ProductList.vue'),
        meta: { title: '商品管理' }
      },
      {
        path: 'spu',
        name: 'Spu',
        component: () => import('@/views/spu/SpuManage.vue'),
        meta: { title: 'SPU管理' }
      },
      {
        path: 'sku',
        name: 'Sku',
        component: () => import('@/views/sku/SkuManage.vue'),
        meta: { title: 'SKU管理' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isLoggedIn) {
      next('/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
